import { gsap } from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollToPlugin);

    window.runScroll = (el, o) => {
        let offsetTop = document.querySelector(el).offsetTop;

        o === undefined ? o = 0 : false;
        
        //document.documentElement.classList.contains('mobile-menu') ? o = 70 : false;
        document.documentElement.classList.contains('mobile-menu') ? window.hideMenu() : false;

        gsap.to(window, {
            duration: .8, 
            scrollTo: {
                y: el,
                offsetY: o,
            },
            onComplete: ()=> {
                document.documentElement.classList.remove('scroll-up');
            }
        });
    };

    const gtt = document.querySelectorAll("[data-target]");

    if (gtt.length > 0) {
        const action = (e) => {
        	e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
            let target = e.currentTarget.dataset.target,
                offset = e.currentTarget.dataset.offset;

            let url = e.currentTarget.href;

            document.querySelector(target) ? window.runScroll(target, offset) :
                window.open(url + target, '_self');
        };

        for (let i = 0; i < gtt.length; i++) {
            gtt[i].addEventListener('click', action);
        }
    }

}, false);
